module.exports = __webpack_public_path__ + "img/hand-heart-line.1758f0d6.svg";